import script from "./AiGameChatPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./AiGameChatPanel.vue?vue&type=script&setup=true&lang=js"

import "./AiGameChatPanel.vue?vue&type=style&index=0&id=145fb81e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-145fb81e"]])

export default __exports__